import {
  GET_MEETING,
  GET_MEETINGS,
  GET_MEETINGS_FOR_CONTACT,
  GET_MEETINGS_FOR_PROJECT,
  REQUEST_ADD_MEETING,
  SUCCESS_ADD_MEETING,
  REQUEST_UPDATE_MEETING,
  SUCCESS_UPDATE_MEETING,
  REQUEST_DELETE_MEETING,
  SUCCESS_DELETE_MEETING,
  SELECT_DAY,
  SELECT_CALENDAR_USERS,
  TOGGLE_CALENDAR_USER
} from '../mutation-types'

const state = {
  all: [],
  meetingCreated: null,
  meetingUpdated: null,
  meetingDeleted: null,
  meeting: null,
  selectedDay: {
    time: null,
    origin: null
  },
  meetingContact: [],
  meetingProject: [],
  selectedUsers: [] // Ids of selected users [1, 6]
}

const mutations = {
  [GET_MEETING] (state, meeting) {
    state.meeting = meeting
  },
  [GET_MEETINGS] (state, meetings) {
    state.all = meetings
  },
  [GET_MEETINGS_FOR_CONTACT] (state, meetings) {
    state.meetingContact = meetings
    // state.meetingContact = meetings.reverse()
    // console.log('GET_MEETINGS_FOR_CONTACT ' + JSON.stringify(meetings))
  },
  [GET_MEETINGS_FOR_PROJECT] (state, meetings) {
    state.meetingProject = meetings
  },
  // Add
  [REQUEST_ADD_MEETING] (state) {
    state.meetingCreated = null
  },
  [SUCCESS_ADD_MEETING] (state) {
    state.meetingCreated = true
  },
  // Update
  [REQUEST_UPDATE_MEETING] (state) {
    state.meetingUpdated = null
  },
  [SUCCESS_UPDATE_MEETING] (state, meeting) {
    state.meetingUpdated = true
    state.meeting = meeting
  },
  // Delete
  [REQUEST_DELETE_MEETING] (state) {
    state.meetingDeleted = null
  },
  [SUCCESS_DELETE_MEETING] (state) {
    state.meetingDeleted = true
    state.meeting = null
  },
  [SELECT_DAY] (state, selectedDay) {
    state.selectedDay = selectedDay
  },
  [SELECT_CALENDAR_USERS] (state, selectedUsers) {
    // if null ajouter user courant
    // quid selectedUsers est Object
    // => TOGGLE_CALENDAR_USERS [object Object],2 push 2 !!!
    console.log('meetings.js SELECT_CALENDAR_USERS ' + JSON.stringify(selectedUsers))
    state.selectedUsers = selectedUsers
  },
  [TOGGLE_CALENDAR_USER] (state, userId) {
    if (state.selectedUsers.indexOf(userId) > -1) {
      return state.selectedUsers.splice(state.selectedUsers.indexOf(userId), 1)
    }
    state.selectedUsers.push(userId)
    console.log('meetings.js TOGGLE_CALENDAR_USERS ' + JSON.stringify(state.selectedUsers) + ' push ' + userId)
  }
}

export default { state, mutations }



// WEBPACK FOOTER //
// ./src/vuex/modules/meetings.js